export const getLocationEventsForDateCount = (year, month, state) =>
  state.getIn(['metering', 'events', year, month], 0);
